import { IGetState, TBoardId, TCardId } from './../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import {
    SegmentCardEvent,
    SegmentCardOptions,
    SegmentCardSection,
    segmentTrackAction
} from '../../../../../../../../middlewares/segment';
import { getSectionType } from '../../../../selectors/getSectionType';
import { ESettingsSectionType } from '../../../../../../base/components/SettingsSection/types';
import { disallowedSectionClickedEvent } from '../../../../effects/segmentEvents';
import { getBoardIsCardDefaultProperty } from '../../../../../../../../store/model/board/selectors/getBoardIsCardDefaultProperty';
import { getCardDependenciesCount } from '../../../../../../../../store/model/dependencies/dependencies/selectors/getCardDependenciesCount';
import { EAsidePanelProperty } from '../../../../../asidePanel/components/AsidePanel/types';
import { showSnoozeBlocker } from '../../../../../../base/effects/showSnoozeBlocker';
import { SegmentCardSourceValue } from 'app/middlewares/segment/trackEntities/cardEvents';

export const onClick = (
    boardId: TBoardId,
    cardId: TCardId,
    ownOnClick?: () => void
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const isFirst = !getCardDependenciesCount(getState(), cardId) &&
            !getBoardIsCardDefaultProperty(getState(), boardId, EAsidePanelProperty.CARD_DEPENDENCIES);
        dispatch(segmentTrackAction(SegmentCardEvent.BUTTONS_PANEL_BUTTON_CLICKED, {
            name: SegmentCardOptions.TARGET,
            value: SegmentCardSection.DEPENDENCIES
        }, [{
            name: SegmentCardOptions.FIRST,
            value: String(isFirst)
        }]));
        if (ownOnClick) ownOnClick();

        const sectionType = getSectionType(getState(), boardId, cardId, null, 'allowDependencies');
        const isDisallow = sectionType === ESettingsSectionType.DISALLOW;

        if (isDisallow) {
            dispatch(showSnoozeBlocker({
                allow: 'allowDependencies'
            }));
            dispatch(disallowedSectionClickedEvent(SegmentCardSection.DEPENDENCIES, SegmentCardSourceValue.BUTTONS_PANEL));
        }
    };
    return action;
};
